import {
  Box,
  Card,
  Grid,
  SvgIcon,
  IconButton,
  // CardHeader,
  CircularProgress,
  CardContent,
  Stack,
  Typography,
} from '@mui/material';
// eslint-disable-next-line import/no-unresolved

import { ReactComponent as Globe } from 'assets/images/ic_globe.svg';
import { useEffect, useState } from 'react';
import { SensitivityService } from 'services/SensitivityService';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { BROADCAST_MESSAGES } from 'shared/Constants';
import useBroadCast from 'shared/hooks/useBroadCast';
import { Toast } from 'shared/helpers';
import { BaseApplicationState } from 'state/baseapplication/Reducer';
import { useSelector } from 'react-redux';

// const CardGlobe: CardBiometric = CardHeader;
const BiometricDataStatus: React.FC<BiometricData> = ({ onEdit }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [types, setTypes] = useState<ISensitivityType[]>([]);
  const { orgACLConfig }: BaseApplicationState = useSelector(
    (state: any) => state.baseAppState
  );
  // API Calls

  const loadTypes = (): void => {
    setIsLoading(true);
    SensitivityService.getAll()
      .then((response) => {
        const { data } = response.data;
        setTypes(data?.sensitivityTypes);
        console.log(data);
      })
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  };
  const deleteType = (id: string): void => {
    SensitivityService.deleteType(id)
      .then(() => {
        Toast.showSuccessMessage('Sensitivity type deleted successfully.');
        loadTypes();
      })
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Hooks
  useBroadCast({
    eventName: BROADCAST_MESSAGES.RELOAD_SENSITIVITY,
    onBroadCast: () => {
      loadTypes();
    },
  });
  useEffect(() => {
    loadTypes();
  }, []);

  // UI Elements
  return (
    <>
      {isLoading && (
        <Box className="empty-content">
          <CircularProgress />
        </Box>
      )}
      {!isLoading && (
        <Box className="biometric-data-wrapper">
          <Grid container className="data-wrapper" spacing={3}>
            {types.map((type) => (
              <Grid key={type.name} item lg={4} sm={6} xs={12}>
                <Card variant="outlined" sx={{ height: '100%' }}>
                  <CardContent>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Stack>
                        <Stack alignItems="center" spacing={2} direction="row">
                          <Typography variant="h6">{type.name}</Typography>
                          {type.isGlobal && (
                            <SvgIcon
                              component={Globe}
                              inheritViewBox
                              className="view-icon"
                              fontSize="small"
                              htmlColor="#d1f27a"
                            />
                          )}
                        </Stack>
                        <Typography variant="h6" style={{ color: 'gray' }}>
                          {type.description ? type.description : '-'}
                        </Typography>
                      </Stack>

                      <Stack direction="row">
                        {!type.isGlobal && (
                          <>
                            {orgACLConfig.aiInventory?.includes(
                              'aiInventory.sensitivityTypes.editSensitivity'
                            ) && (
                              <IconButton
                                onClick={() => {
                                  if (onEdit) {
                                    onEdit(type);
                                  }
                                }}
                                aria-label="edit"
                              >
                                <EditIcon sx={{ color: '#1976d2' }} />
                              </IconButton>
                            )}
                            {orgACLConfig.aiInventory?.includes(
                              'aiInventory.sensitivityTypes.deleteSensitivity'
                            ) && (
                              <IconButton
                                onClick={() => {
                                  deleteType(type._id);
                                }}
                              >
                                <DeleteIcon sx={{ color: 'red' }} />
                              </IconButton>
                            )}
                          </>
                        )}
                      </Stack>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </>
  );
};

export default BiometricDataStatus;
